import React, { PropsWithChildren } from "react";
import {
  ButtonProps,
  Input,
  InputProps,
  SelectProps,
} from "@clarkinc/zest-design-system/ui";
import { cls } from "cls";
import AddToCart, { AddToCartProps } from "../AddToCart";

export interface AddToCartWithQuantityProps extends PropsWithChildren {
  buttonProps: AddToCartProps;
  inputProps: InputProps;
  size?: ButtonProps["size"];
}

const AddToCartWithQuantity = ({
  buttonProps,
  inputProps,
  size,
  children,
}: AddToCartWithQuantityProps) => {
  const { className: buttonClassName, ...restButtonProps } = buttonProps;
  const { className: inputClassName, ...restInputProps } = inputProps;

  return (
    <span className="flex">
      <Input
        labelProps={{ className: "mb-0" }}
        className={cls(
          "wss rounded-r-none text-center border-r-0",
          "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
          inputClassName,
        )}
        id="qty"
        name="qty"
        type="number"
        inputSize={size as SelectProps["inputSize"]}
        {...restInputProps}
      />
      <AddToCart
        className={cls("rounded-l-none", buttonClassName)}
        size={size}
        {...restButtonProps}
      >
        {children}
      </AddToCart>
    </span>
  );
};

export default AddToCartWithQuantity;
